// Ajax CSRF
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
});

$(() => {
    // Logout form
    $('#logout-link').click((event) => {
        event.preventDefault();
        document.getElementById('logout-form').submit();
    });
    $('#logout-link_2').click((event) => {
        event.preventDefault();
        document.getElementById('logout-form').submit();
    });

    function formatCC(creditCard) {
        if (!creditCard.id) {
            return creditCard.text;
        }
        var type = $(creditCard.element).attr('data-type');
        var $card = $(
            '<span class="d-flex flex-row"><i class="' + type + ' fa-2x my-auto"></i><span class="my-auto ml-3">' + creditCard.text + '</span></span>'
        );
        return $card;
    }

    // Select 2
    $.fn.select2.defaults.set('theme', 'bootstrap4');
    $('.select2').select2();
    $('.select2-cc').select2({
        templateResult: formatCC,
        templateSelection: formatCC,
    });

    // Date Time Picker


    // Tooltips
    $('[data-toggle="tooltip"]').tooltip();

    // File Upload
    bsCustomFileInput.init();

    $('#deleteMedia').on('click', () => {
        $('#delete_media').click();
        $('#hide_1').addClass('d-none');
        $('#hide_2').addClass('d-none');
    });

    window.addEventListener('profileUpdate', () => {
        $('#profileModal').modal('hide');
        toastr.success('Su perfil fue actualizado correctamente.');
    });
    window.addEventListener('changePassword', () => {
        $('#passwordModal').modal('hide');
        toastr.success('Su contraseña fue actualizada correctamente.');
    });
    window.addEventListener('eventUpdate', (event) => {
        $(event.detail.id).modal('hide');
        toastr.success('Su evento fue actualizado correctamente.');
    });

    window.addEventListener('errorCard', (event) => {
        $('#newCard').modal('hide');
        setTimeout(function () {
            $('#newCard').modal('show');
        }, 1000);
    });

    window.addEventListener('createdCard', (event) => {
        $('#newCard').modal('hide');
        toastr.success('Su tarjeta fue ingresada correctamente.');
    });

    window.addEventListener('addCardToSelect', (event) => {
        var card = event.detail.card;
        var newOption = new Option('•••• ' + card.number, card.id, false, true);
        newOption.setAttribute('data-type', card.type);
        $('.select2-cc').append(newOption).trigger('change');
    });

    window.addEventListener('errorToastr', (event) => {
        toastr.error(event.detail.message);
    })

    $('.form-disable').submit(function () {
        $(this).find("button[type='submit']").prop('disabled', true).html('<div class="spinner-border" role="status"><span class="sr-only">Guardando...</span></div>');
    });

    $('#storeModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget)
        var name = button.data('name')
        var img = button.data('img')
        var address = button.data('address')
        var telephone = button.data('telephone')
        var website = button.data('website')
        var instagram = button.data('instagram')

        var modal = $(this)
        modal.find('#storeModalLabel').text(name);
        modal.find('#storeModalImg').attr('src', img).prop("alt", name);
        modal.find('#storeModalAddress').text(address);
        modal.find('#storeModalTelephone').text(telephone);
        if (website) {
            modal.find('#storeModalWebsite').html("<a href='" + website + "' target='_blank'>" + website + "</a>");
        } else {
            modal.find('#storeModalWebsite').html("");
        }
        if (instagram) {
            modal.find('#storeModalInstagram').html("<a href='" + instagram + "' target='_blank'>Instagram</a>");
        } else {
            modal.find('#storeModalInstagram').html("");
        }
    })

    $('#newCard').on('show.bs.modal', function (event) {
        $('#number').val('');
        $('#exp').val('');
        $('#cvv').val('');
        $('#first_name').val('');
        $('#last_name').val('');

        var card = new Card({
            form: '#cardForm',
            container: '.card-wrapper',
            formSelectors: {
                numberInput: 'input#number',
                expiryInput: 'input#exp',
                cvcInput: 'input#cvv',
                nameInput: 'input#first_name, input#last_name'
            },
            placeholders: {
                number: '**** **** **** ****',
                name: 'John Doe',
                expiry: '**/**',
                cvc: '***'
            },
        });
    });
});

